import { AuthActions, AuthState, GoogleLoginRequestSuccess, LoginRequestSuccess, MFASetupVerifyRequestSuccess, MFAVerifyRequestSuccess } from 'redux/types/authActionModel';
import { setLocalStorageValue } from 'shared/service/CommonService';
import { LocalStorageKey } from 'shared/utils/Constants';
import * as actionTypes from '../actionTypes';

const initialState: AuthState = {
    refreshToken: '',
    isLoading: false,
    error: null,
    roleId: 0,
    showAddMFAModal: false
};

const handleToken = (action: LoginRequestSuccess | GoogleLoginRequestSuccess | MFAVerifyRequestSuccess | MFASetupVerifyRequestSuccess) => {
    if (action.payload.access_token && action.payload.refresh_token) {
        setLocalStorageValue(LocalStorageKey.ACCESS_TOKEN, action.payload.access_token.toString());
        setLocalStorageValue(LocalStorageKey.REFRESH_TOKEN, action.payload.refresh_token.toString());
    }
}

export const authReducer = (state = initialState, action: AuthActions): AuthState => {
    switch (action.type) {
        case actionTypes.LOGIN_REQUEST:
        case actionTypes.GOOGLE_LOGIN_REQUEST:
        case actionTypes.MFA_VERIFY_REQUEST:
        case actionTypes.MFA_SETUP_REQUEST:
        case actionTypes.MFA_SETUP_VERIFY_REQUEST:
            return {
                ...state,
                isLoading: true,
                error: null,
            };
        case actionTypes.LOGIN_REQUEST_SUCCESS:
        case actionTypes.GOOGLE_LOGIN_REQUEST_SUCCESS: {
            const updatedState = {
                ...state,
                isLoading: false,
                accessToken: action.payload.access_token,
                refreshToken: action.payload.refresh_token || state.refreshToken,
                mfaRequired: action.payload.mfa_required,
                mfaSetupRequired: action.payload.mfa_setup_required,
            };

            // Only set tokens if MFA is not required
            handleToken(action)

            return updatedState;
        }
        case actionTypes.MFA_VERIFY_REQUEST_SUCCESS:
        case actionTypes.MFA_SETUP_VERIFY_REQUEST_SUCCESS: {
            const updatedState = {
                ...state,
                isLoading: false,
                accessToken: action.payload.access_token,
                refreshToken: action.payload.refresh_token || state.refreshToken,
                showAddMFAModal: false
            };
            handleToken(action)
            return updatedState;
        }
        case actionTypes.MFA_SETUP_REQUEST_SUCCESS:
            return {
                ...state,
                isLoading: false,
                mfaQrCode: action.payload.qrCode,
                mfaSecret: action.payload.secret,
                error: null,
            };
        case actionTypes.LOGIN_REQUEST_FAILURE:
        case actionTypes.GOOGLE_LOGIN_REQUEST_FAILURE:
        case actionTypes.MFA_SETUP_REQUEST_FAILURE:
        case actionTypes.MFA_VERIFY_REQUEST_FAILURE:
        case actionTypes.MFA_SETUP_VERIFY_REQUEST_FAILURE:
            return {
                ...state,
                isLoading: false,
                error: action.payload.error,
            };
        case actionTypes.RESET_MFA_STATE:
            return {
                ...state,
                mfaSetupRequired: false,
                mfaRequired: false,
                mfaQrCode: null,
                mfaSecret: null
            };
        case actionTypes.SHOW_ADD_MFA_MODAL:
            return {
                ...state,
                showAddMFAModal: action.payload
            };

        case actionTypes.REMOVE_TOKENS:
            return initialState;
        default:
            return {
                ...state,
            };
    }
};
